import React, { Component } from 'react'

import UpdateUserData from '../../forms/UpdateUserData'
import Font from '../../atoms/Font'
import Modal from '../../atoms-v2/Modal'
import * as user from '../../../utils/userData'

import T from '../../../translate/T'

export default class CompleteUserData extends Component {

    state = {
        active: false,
        fields: []
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.active && nextProps.active !== this.props.active) {
            if(this.props.handleOpened) this.props.handleOpened()
            

            user.verifySurvey()
            .then(resp => {
                if(resp.length === 0) {
                    this.handleComplete()
                    return false
                }
            
                this.setState({
                    active: true,
                    fields: resp
                })
           })   
        }
    }

    handleComplete() {
        this.setState({
            active: false
        })
        this.props.handleDone()
    }

    render() {
        return (
            <Modal style={{width: '500px'}} hideClose={true} active={this.state.active} handleClose={() => {}}>
                <div style={{textAlign: 'center'}}>
                    <Font size='30'>{T.text('first_of_all')}</Font>
                    <Font style={{marginTop: '20px', marginBottom: '40px'}}>
                        {T.text('information_incomplete')}
                    </Font>

                    <UpdateUserData fields={this.state.fields} onUpdate={() => { this.handleComplete() }} />
                </div>
            </Modal>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/container/CompleteUserData/index.js